import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function DeleteImageModal({ id, cancelModal, fetchData }) {
  const [deleteComplete, setDeleteComlete] = useState(false);
  const [isLoading,setIsLoading] = useState(false)
  const { user } = useAuthContext();

  //styled

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const imgDeleteResponse = await axios.delete(
        `${ApiConnectionString}/api/PendingImage/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (imgDeleteResponse.status === 200) {
        setDeleteComlete(true);
    
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      // Optionally, handle the error (e.g., show a message to the user)
    } finally {
      setIsLoading(false); // Ensure the loading state is reset
    }
  };

  if(isLoading){
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
      
     
<LoadingSpinner />
          <div className="send-modal-footer">
      
          </div>
        </div>
      </div>
    );
  }else{

  
  

  if (deleteComplete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Image Deleted</p></div> 
      
        <p>The image has been successfully deleted.</p>

          <div className="send-modal-footer">
          <button
                  onClick={() => {    fetchData();cancelModal()}}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                Okay
                </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Image Deleted</p></div>
        <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button> 
   <p>Are you sure you want to delete this image?</p>
          <img
            src={`${ApiConnectionString}/api/PendingImage/${id}`}
            alt="Club Image"
            width={200}
            className="img-fluid"
          />
          <div className="send-modal-footer">
            <button className="saveChanges-button mx-3" onClick={handleDelete}>
            Confirm
            </button>
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
          </div>
        </div>
      </div>
    );
  }
}
}